import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'button-remove',
  templateUrl: './button-remove.component.html',
  styleUrls: ['./button-remove.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonRemoveComponent {

  @Input() readonly isDisabled: boolean;
  @Input() readonly tooltip: string = 'general_lang_delete';
  @Input() readonly tooltipPosition: 'above' | 'right' | 'bottom' | 'left' = 'above';

  @Output() readonly onClick = new EventEmitter<void>();

}
